// Centralized image URLs & content constants for the site.

export const LOGO_URL = "/logo-mark.png";
export const LOGO_FULL_URL = "https://customer-assets.emergentagent.com/job_campaign-moment/artifacts/507j6ebf_Marketing%20for%20the%20Moment%20Logo%20%281%29.png";
export const HEADSHOT_URL = "https://customer-assets.emergentagent.com/job_campaign-moment/artifacts/l05zrk9e_AB-photo%20%284%29.jpg";
export const CHRYSLER_URL = "https://images.pexels.com/photos/31253937/pexels-photo-31253937.jpeg?auto=compress&cs=tinysrgb&w=1800";
export const LINKEDIN_URL = "https://www.linkedin.com/in/andrea-brown-b0730a29/";

export const BRIDGE_STORY = {
  eyebrow: "Why I do this",
  headline_1: "From boardrooms",
  headline_2: "to kitchen tables.",
  chips: ["Toronto Blue Jays · MLB", "Fortune 100 Technology", "QSR Family Franchise · 25+ years"],
  paragraphs: [
    "For more than two decades in my career, I have conducted marketing for the biggest names in the room — an MLB team, a Fortune 100 tech firm, and a franchise powerhouse started by three friends. Closer to home, my parents owned a small claims-adjusting business and I married into a family business within the shade of the golden arches.",
    "But my real schooling didn't happen in glass towers.",
    "I was raised by two parents constantly stressed trying to meet payroll and keep a regional insurance business going. I built my adult life alongside a man whose family business was running five locations of the most famous quick-service restaurant in America. The type of buildings where a lunch crush was not survivable without the incredibly hard-working restaurant staff that showed up on their toughest days with a smile on their face. That means I know the truth of small business — the loudest decisions never get made in offices. They get made at a kitchen table where the heat of the argument may be rising while the temp of the meal is growing cold. They get made in exasperation after an endless conversation that distorts the meaning of pillow talk.",
    "Small businesses aren't built by MBAs and PowerPoints. They're built by people with an honest, hands-earned talent for one specific thing — the perfect loaf, the fair estimate, the calm kindness with a nervous patient. What most family businesses don't have — and shouldn't be expected to have — is a head built for the maze of modern marketing.",
  ],
  pullquote: "That's the bridge I want to be.",
  paragraphs_after: [
    "I take everything the corporate giants use to look polished, professional, and mighty, and I hand-deliver a piece of it to you — quietly, thoughtfully, and at a price that respects your life. I honor the skill that already sits in your hands. I dress it in a design that finally matches the level you actually operate at.",
  ],
  closing_line_1: "You bring passion and hard work.",
  closing_line_2: "I bring modern vibes and technology to your authentic story.",
  signoff: "— Andrea",
};

export const IMAGES = {
  hero: "https://customer-assets-cm19k8pv.emergentagent.net/job_campaign-moment/artifacts/w2c020rq_Andrea%20Desk.webp",
  portfolio: {
    landscaper: "https://images.pexels.com/photos/31291000/pexels-photo-31291000.png",
    restaurant: "https://images.pexels.com/photos/2387675/pexels-photo-2387675.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    dentist: "https://images.pexels.com/photos/7800666/pexels-photo-7800666.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    bakery: "https://images.pexels.com/photos/3341067/pexels-photo-3341067.jpeg",
    plumber: "https://images.pexels.com/photos/6419128/pexels-photo-6419128.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
};

export const BUSINESS_TYPES = [
  "Landscapers", "Dentists", "Restaurants", "Plumbers", "Cafés", "Electricians",
  "Bakeries", "Salons", "Contractors", "Florists", "Veterinarians", "Mechanics",
];

export const TIERS = [
  {
    id: "tomorrow",
    name: "Tomorrow",
    subtitle: "Same-day, by me",
    subhead: "The Same-Day Site",
    price: 750,
    priceLabel: "$750",
    timeline: "Live in 24 hours",
    tagline: "A brilliant website. Running 24/7. Personally designed by me.",
    description:
      "You tell me about your business today. Tomorrow you have a beautiful website with your name, your story, your hours, your services, and a contact form that lands in your inbox. No template factory — I design every one myself.",
    features: [
      "Custom 1-page website, designed by Andrea (not a template)",
      "Your business name, hours, services & contact info",
      "Mobile-first, Google-ready, fast to load",
      "Domain setup help included",
      "Contact form that emails you the moment someone writes",
      "Live in 24 hours from the time we say go",
      "Free edits for one month after launch",
      "One 15-minute consult for $15 — available every month",
    ],
    cta: "Start tomorrow",
    highlighted: false,
  },
  {
    id: "coffee",
    name: "Coffee & a Plan",
    subtitle: "Bookings, payments, strategy",
    subhead: "The Strategy Build",
    price: 1500,
    priceLabel: "$1,500",
    timeline: "Live within a week",
    tagline:
      "We sit down (virtually or in person) over coffee, talk about what's working and what's quietly broken — and I build the site that fixes it.",
    description:
      "Before I touch a pixel, we have an honest conversation. How can we get more customers into your door? How can we offer your product in new ways? How can we help your employees at their worst pain points, like having to answer the same question dozens of times a day? Then I build a site that quietly answers those questions for you — with the right tools wired in.",
    features: [
      "Everything in The Same-Day Site, plus —",
      "60-minute discovery conversation (coffee on me, virtually)",
      "Online reservations or appointment booking (Calendly, OpenTable, Resy)",
      "Estimate-request flow with photos & details",
      "Online payments or deposits (Stripe / Square)",
      "Google Business Profile tune-up & reviews widget",
      "3 thoughtfully designed pages with your story baked in",
    ],
    cta: "Let's grab coffee",
    highlighted: true,
  },
  {
    id: "cinematic",
    name: "Cinematic",
    subtitle: "Fully custom · hands-off",
    subhead: "The Signature Site",
    price: 3000,
    priceLabel: "$3,000",
    timeline: "Live in 2–3 weeks",
    tagline:
      "A fully custom, cinematic website that captures not just who you are — but the difference you make in your community.",
    description:
      "For the businesses ready to look the way they actually feel inside. I direct the imagery (or source cinematic stock), write every word, and weave your story together so the site has soul. You don't lift a finger. Authenticity is everything in 2026, and this is how you show yours.",
    features: [
      "Everything in The Strategy Build, plus —",
      "Cinematic photography direction (or premium sourced imagery)",
      "Custom written brand storytelling — your real voice, polished",
      "Multi-page custom design (5–8 pages) with bespoke layouts",
      "Subtle motion & micro-interactions for a premium feel",
      "Built-in newsletter sign-up & light marketing automation",
      "A full review of digital partners such as reservation schedulers, appointment setters, delivery partners, and estimate builders that would help you grow",
      "60 days of post-launch polishing — anything that needs adjusting",
    ],
    cta: "Build my signature site",
    highlighted: false,
  },
];

export const WHY_ITEMS = [
  {
    title: "Stop answering the same five questions all day.",
    body: '"What time do you close?" "Are you taking new clients?" "Where exactly are you?" Your website answers them — calmly, beautifully, around the clock.',
  },
  {
    title: "Reservations & appointments, while you sleep.",
    body: "Tier 2 and Tier 3 let customers book a table, an estimate, or an appointment online. You wake up to a full calendar instead of voicemails.",
  },
  {
    title: "Look like the legitimate, trusted business you are.",
    body: "A real website tells new customers you're established and serious. The kind of place they're happy to trust — and recommend.",
  },
  {
    title: "If you ever sell — your business is worth more.",
    body: "Thinking of selling in the next 5 years? A polished, working website is a standard expectation buyers look for. It quietly adds real value to your company.",
  },
];

export const ADDONS = [
  { title: "Calendly booking", body: "Let clients pick a time on your calendar — no back-and-forth emails. Perfect for consultations and appointments." },
  { title: "Restaurant reservations", body: "Connect OpenTable, Resy, or a simple built-in form so diners can book a table from your site." },
  { title: "Estimate request form", body: "Capture project details — square footage, services needed, photos — so quotes are faster to send." },
  { title: "AI reply assistant", body: "An optional chatbot trained on your business that answers common questions and hands off serious leads to you." },
  { title: "Google reviews widget", body: "Show your best Google reviews right on the site, refreshed automatically. Social proof, on autopilot." },
  { title: "Deposits & payments", body: "Take a deposit or full payment online with Stripe or Square — no monthly software fee, just standard processing." },
];

export const STEPS = [
  { n: "01", title: "Tell me about you", body: "Five-minute form or a quick call. Your business, your customers, your hours, your story — that's all I need to start." },
  { n: "02", title: "I design — by hand", body: "I personally lay out your site. No factory, no template. You get a real draft within hours (Tier 1) or days (Tier 2 & 3)." },
  { n: "03", title: "A friendly review", body: "We tweak the wording, swap a photo, change a color. Until it feels exactly like you." },
  { n: "04", title: "Launch", body: "Your site goes live on your domain — sometimes by tomorrow, sometimes a few weeks later. Always smoothly." },
];

export const PORTFOLIO = [
  { name: "Greenview Landscape Co.", type: "Landscaper · Boutique residential", img: "landscaper" },
  { name: "Maple & Ember", type: "Restaurant · Neighbourhood bistro", img: "restaurant" },
  { name: "Cedar Smile Dental", type: "Dentistry · Family practice", img: "dentist" },
  { name: "Northside Bakery", type: "Bakery · Sourdough & coffee", img: "bakery" },
  { name: "Riverbend Plumbing", type: "Plumber · Trusted local trade", img: "plumber" },
];

export const TESTIMONIALS = [
  {
    quote: "I'd been putting off a website for five years. Andrea made it feel like a conversation over coffee — and we had something beautiful within a few weeks.",
    name: "Maria L.",
    role: "Owner, neighbourhood café",
  },
  {
    quote: "Bookings doubled in the first two months. More importantly, I'm proud to send people to my site now. That's a feeling I didn't expect.",
    name: "James R.",
    role: "Residential landscaper",
  },
  {
    quote: "Warm, professional, and refreshingly honest about what we actually needed. Not a single upsell. Andrea is the real deal.",
    name: "Dr. Priya S.",
    role: "Family dentistry practice",
  },
];

export const FAQS = [
  {
    q: "Can I really have a website by tomorrow?",
    a: "Yes — as long as you can send me your business details (name, hours, services, a few photos, and how you'd like to be reached) by early afternoon today, your Same-Day Site goes live within 24 hours. It's a real, hand-designed site — not a template with your name pasted on.",
  },
  {
    q: "What's the difference between the three tiers?",
    a: "Tomorrow ($750) is a beautifully-designed one-page site — perfect if you just need to exist online, professionally, right now. Coffee & a Plan ($1,500) adds a strategy conversation and the tools that actually save you time — bookings, estimates, payments. Cinematic ($3,000) is the fully custom, multi-page signature site where I direct the story, imagery, and every word. Same care in each — just deeper as we go.",
  },
  {
    q: "Why isn't this a monthly subscription?",
    a: "Because you shouldn't have to pay rent on your own front door. Most website platforms lock you into $30–$100/month forever, and the moment you stop paying, your site vanishes. I charge once, hand you the keys, and you own it. That's the whole point.",
  },
  {
    q: "What if I need hosting and a domain?",
    a: "I'll help you set both up — no charge for the guidance. Hosting typically runs $10–$20/month and a domain is around $15/year. You pay those providers directly (never me), so you always own everything.",
  },
  {
    q: "Will my site work on phones?",
    a: "Absolutely. Every site I build is mobile-first — meaning I design for the phone before the desktop. More than 70% of your customers will find you on a phone, and I want that experience to feel effortless.",
  },
  {
    q: "Can I update the site myself afterwards?",
    a: "Yes — I hand over a simple content editor for text and photo swaps, plus a short video walking you through it. For bigger changes (new pages, redesigns), you can always come back to me and I'll quote it honestly.",
  },
  {
    q: "What if I don't have a logo or good photos?",
    a: "That's more common than you'd think, and completely fine. In Tier 1, I'll design a clean wordmark from your business name. In Tier 2 & 3, I can source cinematic stock imagery or coordinate a local photographer. You never need to have everything perfect before we start.",
  },
  {
    q: "I might sell my business one day — does a website help?",
    a: "Meaningfully, yes. Buyers look for a professional online presence as a baseline sign that the business is a real, functioning operation. A polished site with reviews, clear services, and working booking or contact flows quietly adds credibility (and often, real dollars) to your sale price.",
  },
  {
    q: "Do you only work with local businesses?",
    a: "I work with small and family-run businesses everywhere in North America. Most of my clients are within a few hours' drive of me, but I've built beautiful sites for owners I've only ever met over video coffee.",
  },
  {
    q: "What if I'm not happy?",
    a: "We keep tweaking. Every tier includes a friendly review round where we adjust wording, photos, and layout until it feels like you. Tier 3 also includes 60 days of post-launch polishing at no extra cost. My name is on this work — I want you to genuinely love it.",
  },
];

export const BUSINESS_TYPE_OPTIONS = [
  "Choose one",
  "Landscaper",
  "Dentist / Medical Practice",
  "Restaurant / Café",
  "Plumber / Trades",
  "Salon / Spa",
  "Retail / Boutique",
  "Other",
];

export const NAV_LINKS = [
  { label: "About", href: "/about" },
  { label: "Tiers & Pricing", href: "/#tiers" },
  { label: "Kind Words", href: "/#kind-words" },
  { label: "FAQ", href: "/#faq" },
];
